import api from '.';

export const TIPO_OPORTUNIDADES_ENDPOINT = '/tipo-oportunidades';
export const TIPO_OPORTUNIDADES_KVP_ENDPOINT = `${TIPO_OPORTUNIDADES_ENDPOINT}/kvp`;

export const getAllTipoOportunidadesAsKvpList = async () => {
    const response = await api.get(TIPO_OPORTUNIDADES_KVP_ENDPOINT);
    return response;
};
